import http from "./HttpService";

var endpoint = `/reporting/analytics/nys/`;

const headers = {};

const getRace = async (year) => {
    const response = await http.get(`${endpoint}race/${year}`);
    return response;
};

const getQualification = async (year) => {
  const response = await http.get(`${endpoint}qualifications/${year}`);
     return response;
};


const getParticipation = async () => {
  const response = await http.get(`${endpoint}participation`);
    return response;
};

const getGender= async (year) => {
  const response = await http.get(`${endpoint}gender/${year}`);
    return response;
};

const getDisability = async (year) => {
    const response = await http.get(`${endpoint}disability/${year}`);
      return response;
  };

  const getAge = async (year) => {
    const response = await http.get(`${endpoint}age/${year}`);
      return response;
  };

const getCandidateOrigin = async (year) => {
  const response = await http.get(`${endpoint}candidate/origin/${year}`);
  return response;
};

const getPlacementLocation = async (year) => {
  const response = await http.get(`${endpoint}placement/location/${year}`);
  return response;
};

const getCandidateActivities = async (year) => {
  const response = await http.get(`${endpoint}candidate/activities/${year}`);
  return response;
};

const getPlacementDuration = async (year) => {
  const response = await http.get(`${endpoint}placement/duration/${year}`);
  return response;
};


const getYearRange = async () => {
  const response = await http.get(`${endpoint}year-range`); 
  return response;
};


export default {
  getRace,
  getQualification,
  getParticipation,
  getGender,
  getDisability,
  getAge,
  getCandidateOrigin,
  getPlacementLocation,
  getCandidateActivities,
  getPlacementDuration,
  getYearRange,
};
